<div class="dialog-letter">
  <h1 mat-dialog-title>{{ 'newsletter.unsubscribeTitle' | t }}</h1>
  <mat-dialog-content class="mat-typography">
    @if (sent) {
      <div class="alert alert-success" id="unsubscribeLinkSent">
        <p class="mb-0">{{ 'newsletter.unsubscribeLinkSent' | t }}</p>
      </div>
    } @else {
      <p>
        {{ 'newsletter.unsubscribeIntro' | t }}
      </p>

      <form [formGroup]="form" (ngSubmit)="submit()">
        <mat-form-field>
          <input matInput type="email" [placeholder]="'common.emailPlaceholder' | t" formControlName="email" />
        </mat-form-field>
      </form>
      @if (error) {
        <div class="alert alert-danger">{{ error }}</div>
      }
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button type="button" mat-dialog-close>{{ 'common.close' | t }}</button>
    @if (!sent) {
      <button type="button" [disabled]="form.invalid || loading" (click)="submit()" cdkFocusInitial
        mat-raised-button id="unsubscribeRequestSubmit">{{ 'common.validate' | t }}</button>
    }
  </mat-dialog-actions>
</div>
